<aside class="rounded-2xl bg-white border border-gray-200 p-6 space-y-6">
  <!-- Filter Section -->
  <h2 class="text-2xl font-extrabold mb-6 text-gray-900 tracking-tight">Order Status</h2>
  <div>
    <div class="grid grid-cols-2 gap-3 text-sm text-gray-700">
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input class="custom-check radio-like" [checked]="selectedFilter==orderStatus.ALL"  (click)="onFilterChange(orderStatus.ALL)" type="checkbox"  value="all" />
        All Orders
      </label>
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input type="checkbox" class="custom-check radio-like" [checked]="selectedFilter==orderStatus.CONFIRMED" (click)="onFilterChange(orderStatus.CONFIRMED)"  value="confirmed" />
        Confirmed
      </label>
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input type="checkbox" class="custom-check radio-like" [checked]="selectedFilter==orderStatus.PACKING" (click)="onFilterChange(orderStatus.PACKING)"  value="packing" />
        Packing
      </label>
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input type="checkbox" class="custom-check radio-like" [checked]="selectedFilter==orderStatus.SHIPPED" (click)="onFilterChange(orderStatus.SHIPPED)"  value="shipped" />
        Shipped
      </label>
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input type="checkbox" class="custom-check radio-like" [checked]="selectedFilter==orderStatus.DELIVERED" (click)="onFilterChange(orderStatus.DELIVERED)"  value="delivered" />
        Delivered
      </label>
      <label class="flex items-center gap-2 cursor-pointer hover:text-[var(--primary)] transition-colors">
        <input type="checkbox" class="custom-check radio-like" [checked]="selectedFilter==orderStatus.CANCELLED" (click)="onFilterChange(orderStatus.CANCELLED)"  value="cancelled" />
        Cancelled
      </label>
    </div>
  </div>
</aside>
